































import { Component, Vue } from 'vue-property-decorator';
import swert from '@/component/swert.vue';
import wx from '@/util/wx';

const { VUE_APP_STAGE_PREFIX: PREFIX } = process.env;

const clipboard = require('clipboard');

@Component({
  components: {
    swert,
  },
})
export default class JoinSuccess extends Vue {
  swert_msg: string = '';
  share_text: string = 'ToGoLive';

  back() {
    this.$router.push({
      path: '/incubation-camp',
    });
  }

  mounted() {
    const clip = new clipboard('#share-text');
    clip.on('success', (e: any) => {
      this.swert_msg = '复制成功，快去添加微信好友吧';
    });
    window.SHARE = {
      title: '家装家居行业线上线下双导购技能训练营',
      description: '小白入门，打通必要环节，开启大家装直播时代',
      url: `https://${PREFIX ? PREFIX : ''}vm.tugou.com/incubation-camp`,
      icon_url: 'https://static.tugou.com/jia/m/apply/img/share.png',
    };
    wx.init();
    wx.bindShare();
    wx.bindShareTimeLine();
  }
}
